import useFlatPickr from "@/utils/hooks/useFlatPickr";
import {
  reactive,
  ref,
  computed,
  getCurrentInstance,
  onBeforeMount,
  watch,
} from "@vue/composition-api";
import usePagination from "@/views/components/pagination/usePagination";
import useReorderTable from "@/views/components/base-table/hooks/useReorderTable";
import useModal from "@/@core/components/base-modal/hooks/useModal";
import Swiper, { Navigation, Pagination } from "swiper";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import winnerAnouncementModel from "@/models/lucky-draw/winner-anouncement";
import store from "@/store";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";

export default function useRoundAndRewardModal(props) {
  const vm = getCurrentInstance().proxy;

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
    openErrorModal,
  } = useValidationModal();

  const {
    createCampaign,
    fetchCampaignList,
    fetchCampaignDetail,
    editCampaign,
    setCampaignStatus,
    setRoundStatus,
    createRound,
    editRound,
    editReward,
    deleteRound,
    fetchRoundDetail,
    createWinner,
    deleteReward,
    fetchDetailReward,
    createReward,
    deleteWinner,
    reorderReward,
    reorderWinner,
  } = winnerAnouncementModel();

  const { openModal, closeModal } = useModal();

  const {
    // sortableRowOptions,
    currentIdSelect,
    currentIndex,
    keyChange,
    tableModeReorder,
  } = useReorderTable();

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,
    resolveReverseDate,
  } = useFlatPickr();

  const formData = reactive({
    campaignid: null,
    mobileLength: 10,
    dragging: false,
    selectedArr: [],
    dataNull: "",
    activeTab: true,
    activeClass: false,
    isOverflowed: false,
    isOverflowDropdown: false,
    isHoverValidFrom: false,
    isHoverValidThrough: false,
    calValidFromDate: null,
    calValidThroughDate: null,
    isMobileLength: false,
    round: {
      roundId: props.formDataObj.roundId,
      status: false,
      nameTh: "",
      nameEn: "",
      created_time: null,
      updated_time: null,
    },
    reward: {
      rewardId: null,
      status: false,
      title: "",
      nameTh: "",
      value: "",
    },
    winner: {
      status: false,
      file: null,
      uploadfile: null,
      templateUrl:
        "https://devbcrmdata.blob.core.windows.net/bcrm-4-bl6zlw8pxbxa/AJAYT7XH1HMV_app-bo-cust/WinnerAnnoucement/Template_WinnerAnnouncement2.csv",
    },
    validFrom: {
      date: null,
      time: null,
    },
    validThrough: {
      date: null,
      time: null,
    },
    image: { file: null, url: null },
    active: false,
    activeIndex: null,
    hoverIndex: null,
    isHover: false,
    isSelectAll: false,
    selectAll: [],
    uploadLoading: {
      value: 0,
      max: 100,
    },
    rewardItem: {
      payload: [],
    },
    winnerListTable: {
      payload: [],
    },
    reorderData: {
      isReorder: false,
      tabId: 0,
    },
  });

  const modalType = reactive({
    winner: false,
    reward: false,
  });

  const loading = reactive({
    tableData: false,
    uploadfile: false,
    uploadWinner: false,
  });

  const fields = [
    { key: "selected", label: "" },
    { key: "seq", label: "No" },
    { key: "first_name", label: "First Name" },
    { key: "last_name", label: "Last Name" },
    { key: "mobile_no", label: "Mobile No" },
    { key: "address", label: "Address" },
  ];

  const ConfigflatpickrDateValidFrom = computed(() => {
    let config = {
      allowInput: true,
      altFormat: "F j, Y",
      dateFormat: "d-m-Y",
      defaultDate: props.formDataObj.validFrom.dt
        ? new Date(props.formDataObj.validFrom.dt)
        : "today",
      minDate: props.formDataObj.validFrom.dt
        ? new Date(props.formDataObj.validFrom.dt)
        : "today",
      maxDate: props.formDataObj.validThrough.dt
        ? new Date(props.formDataObj.validThrough.dt)
        : new Date().fp_incr(30),
      monthSelectorType: "static",
      disableMobile: true,
      onReady(selectedDate, dateStr, instance) {
        const el = instance.element;
        const preventInput = (event) => {
          event.preventDefault();
          return false;
        };
        el.onkeypress = preventInput;
        el.onkeydown = preventInput;
        el.onkeyup = preventInput;
        el.onpaste = preventInput;
        el.onfocusout = preventInput;
        el.onfocus = preventInput;
        el.style.caretColor = "transparent";
        el.style.cursor = "pointer";
      },
    };
    return config;
  });

  const ConfigflatpickrValidThrough = computed(() => {
    let config = {
      allowInput: true,
      altFormat: "F j, Y",
      dateFormat: "d-m-Y",
      defaultDate: props.formDataObj.validThrough.dt
        ? new Date(props.formDataObj.validThrough.dt)
        : new Date().fp_incr(30),
      minDate: props.formDataObj.validFrom.dt
        ? new Date(props.formDataObj.validFrom.dt)
        : "today",
      maxDate: props.formDataObj.validThrough.dt
        ? new Date(props.formDataObj.validThrough.dt)
        : new Date().fp_incr(30),
      monthSelectorType: "static",
      disableMobile: true,
      onReady(selectedDate, dateStr, instance) {
        const el = instance.element;
        const preventInput = (event) => {
          event.preventDefault();
          return false;
        };
        el.onkeypress = preventInput;
        el.onkeydown = preventInput;
        el.onkeyup = preventInput;
        el.onpaste = preventInput;
        el.onfocusout = preventInput;
        el.onfocus = preventInput;
        el.style.caretColor = "transparent";
        el.style.cursor = "pointer";
      },
    };
    return config;
  });

  const roundDetail = (reward) => {
    window.$loading(true);
    fetchRoundDetail.payload.RoundId = props.formDataObj.roundId;

    store
      .dispatch("api/apiRequest", fetchRoundDetail)
      .then((response) => {
        const respData = response.data.resp;

        if (Object.keys(respData).length > 0) {
          formData.campaignid = respData.round.campaignid;
          formData.round.nameTh = respData.round.round_name_th;
          formData.round.nameEn = respData.round.round_name_en;

          formData.validFrom.date = respData.round.valid_form
            ? resolveDate(respData.round.valid_form)
            : props.formDataObj.validFrom.date;
          formData.validFrom.time = respData.round.valid_form
            ? resolveTime(respData.round.valid_form)
            : props.formDataObj.validFrom.time;
          formData.validThrough.date = respData.round.valid_through
            ? resolveDate(respData.round.valid_through)
            : props.formDataObj.validThrough.date;
          formData.validThrough.time = respData.round.valid_through
            ? resolveTime(respData.round.valid_through)
            : props.formDataObj.validThrough.time;

          formData.round.status = respData.round.status == 1;
          formData.round.created_time = respData.round.created_time;
          formData.round.updated_time = respData.round.updated_time;

          if (respData.reward_list.length > 0) {
            formData.rewardItem.payload = respData.reward_list;
            respData.reward_list.map((e) => {
              rewardDetail(e.id);
            });
            formData.selectedArr = [];

            if (formData.activeTab) {
              if (reward) {
                toggleActive(reward);
              } else {
                toggleActive(formData.rewardItem.payload[0]); //active index 0
              }
            }

            if (respData.reward_list.length > 8) {
              checkOverflow(true);
            }
          } else {
            formData.rewardItem.payload = [];
          }
        }
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const rewardDetail = (rewardId) => {
    window.$loading(true);
    fetchDetailReward.payload.RewardId = rewardId;

    store
      .dispatch("api/apiRequest", fetchDetailReward)
      .then((response) => {
        const respData = response.data.resp;
        const rewardItem = [...formData.rewardItem.payload];

        rewardItem.map((item) => {
          if (item.id == respData.reward.rewardid) {
            item.name = respData.reward.reward_name_th || item.title;
            item.value = respData.reward.reward_value || 0;
            item.status = respData.reward.status;
            item.isdisplay_winner = respData.reward.isdisplay_winner;
            item.url = respData.reward.image_url;
            item.winnerListTable = respData.winners;
          }
        });

        formData.rewardItem.payload = rewardItem;
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  let rewardObj = {};
  const toggleActive = (ele) => {
    formData.activeTab = false;
    formData.activeClass = false;
    formData.activeIndex = ele.id;
    rewardObj = formData.rewardItem.payload.find((o) => {
      return o.seq == ele.seq;
    });
    formData.reward.rewardId = ele.id;
    formData.selectedArr = [];
  };

  const reorderRewardStart = () => {
    onUpdateRoundReward();
  };

  const reorderRewardFunc = (event) => {
    fetchRewardReorder(
      formData.rewardItem.payload[event.oldDraggableIndex],
      formData.rewardItem.payload[event.oldDraggableIndex].seq,
      formData.rewardItem.payload[event.newDraggableIndex].seq
    );
    formData.rewardItem.payload.splice(
      event.newDraggableIndex,
      0,
      formData.rewardItem.payload.splice(event.oldDraggableIndex, 1)[0]
    );
  };

  const fetchRewardReorder = (Reward, currentPostion, newPosition) => {
    window.$loading(true);
    reorderReward.payload.RewardId = Reward.id;
    reorderReward.payload.From = currentPostion;
    reorderReward.payload.To = parseInt(newPosition);

    store
      .dispatch("api/apiRequest", reorderReward)
      .then((response) => {
        formData.activeTab = true;

        formData.rewardItem.payload.splice(0);
        roundDetail(Reward);
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const handleRowChange = (event) => {
    if (formData.rewardItem.payload.length > 0) {
      formData.rewardItem.payload.map((ele) => {
        if (ele.winnerListTable.length > 0) {
          if (formData.reward.rewardId == ele.id) {
            fetchWinnerReorder(
              ele.winnerListTable[event.oldDraggableIndex]?.winnerid,
              ele.winnerListTable[event.oldDraggableIndex]?.seq,
              ele.winnerListTable[event.newDraggableIndex]?.seq,
              ele.winnerListTable[event.oldDraggableIndex]?.rewardid
            );
            ele.winnerListTable.splice(
              event.newDraggableIndex,
              0,
              ele.winnerListTable.splice(event.oldDraggableIndex, 1)[0]
            );

            keyChange.value++;
          }
        }
      });
    }
  };

  const fetchWinnerReorder = (
    winnerId,
    currentPostion,
    newPosition,
    rewardid
  ) => {
    reorderWinner.payload.WinnerId = winnerId;
    reorderWinner.payload.From = currentPostion;
    reorderWinner.payload.To = parseInt(newPosition);

    store
      .dispatch("api/apiRequest", reorderWinner)
      .then((response) => {
        rewardDetail(rewardid);
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {});
  };

  const resolveDateFormat = (dateStr) => {
    if (!dateStr) return;
    const dateSplit = dateStr.split("-");
    const date = dateSplit[0];
    const month = dateSplit[1];
    const year = dateSplit[2];

    return `${year}-${month}-${date}`;
  };

  const onUpdateRoundReward = () => {
    if (
      formData.round.nameTh &&
      formData.validFrom.date &&
      formData.validFrom.time &&
      formData.validThrough.date &&
      formData.validThrough.time
    ) {
      onUpdateRound().then((response) => {
        onUpdateReward();
      });
    } else {
      onUpdateReward();
    }
  };

  const onUpdateRound = () => {
    return new Promise((resolve, reject) => {
      const payload = {
        CampaignId: formData.campaignid,
        RoundId: formData.round.roundId,
        Round_Name_TH: formData.round.nameTh,
        Round_Name_EN: formData.round.nameEn,
        Valid_Form:
          formData.validFrom.date && formData.validFrom.time
            ? `${resolveDateFormat(formData.validFrom.date)} ${
                formData.validFrom.time
              }`
            : null,
        Valid_Through:
          formData.validThrough.date && formData.validThrough.time
            ? `${resolveDateFormat(formData.validThrough.date)} ${
                formData.validThrough.time
              }`
            : null,
        Status: formData.round.status == true ? 1 : 2,
      };

      editRound.payload = payload;
      store
        .dispatch("api/apiRequest", editRound)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          openDefaultErrorModal(error);
        })
        .finally(() => {});
    });
  };

  const onUpdateReward = () => {
    const payload = {
      RoundId: formData.round.roundId,
      Rewards: formData.rewardItem.payload.map((e) => ({
        RewardId: e.id,
        Title: e.title,
        Reward_Name: e.name || e.title,
        Image: e.file,
        Image_URL: e.url,
        Reward_Value: e.value || 0,
        Status: e.status == true ? 1 : 2,
        IsDisplay_Winner: e.isdisplay_winner,
      })),
    };
    editReward.payload = payload;
    store
      .dispatch("api/apiFormRequest", editReward)
      .then((response) => {})
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {});
  };

  const sortableRowOptions = reactive({
    chosenClass: "is-selected",
    ghostClass: "ghost-background-class",
    onEnd: handleRowChange,
    dragClass: "sortable-drag",
    disabled: true,
    easing: "cubic-bezier(0.22, 1, 0.36, 1)",
    handle: ".handle", // handle's class
    animation: 150,
  });

  const onHover = (id, hover) => {
    if (hover) {
      formData.isHover = true;
      formData.hoverIndex = id;
    } else {
      formData.isHover = false;
    }
  };

  const onUploadMainImg = (image, ele) => {
    ele.file = image.file;
    ele.url = image.url;
  };

  const selectAllWinner = (isSelected, rewardId) => {
    formData.selectedArr = [];
    if (isSelected) {
      formData.rewardItem.payload.map((ele) => {
        if (rewardId == ele.id) {
          ele.winnerListTable.map((item) =>
            formData.selectedArr.push(item.winnerid)
          );
        }
      });
    }
  };

  const selectItemWinner = () => {
    formData.isSelectAll = false;
  };

  const openWinnerModal = () => {
    onUpdateRoundReward();
    modalType.winner = true;
    vm.$bvModal.show("create-winner-modal");
    openModal();
  };

  const onCloseModalWinner = () => {
    vm.$bvModal.hide("create-winner-modal");
  };

  const onResolveAcceptFileArray = (acceptFile) => {
    if (typeof acceptFile == "string") {
      return acceptFile.split(" ");
    } else if (typeof acceptFile == "object") {
      return acceptFile;
    } else {
      console.error("invalid accept file");
      return;
    }
  };

  const acceptFile = ref([".csv", ".xls", ".xlsx"]);

  const isNext = ref(true);
  const onChangeFileValue = (file) => {
    formData.winner.uploadfile = file;

    if (file) {
      isNext.value = false;
    } else {
      isNext.value = true;
    }
    onSubmitWinnerModal();
  };

  const onInputFile = (file) => {
    if (!file) return;
    loading.uploadfile = true;
    const _validFileExtensions = onResolveAcceptFileArray(acceptFile.value);

    const fileName = file.name;
    if (fileName.length > 0) {
      var isValidExtension = false;
      var fileExtension = null;

      for (var i = 0; i < _validFileExtensions.length; i++) {
        var curExtension = _validFileExtensions[i];
        fileExtension = fileName
          .substr(fileName.length - curExtension.length, curExtension.length)
          .toLowerCase();

        if (fileExtension == curExtension.toLowerCase()) {
          isValidExtension = true;

          formData.winner.fileUpload = file;
          onChangeFileValue(file);
          break;
        }
      }

      if (!isValidExtension) {
        openErrorModal(
          "อัพโหลดไฟล์ไม่ถูกต้อง",
          "<div>กรุณาอัพโหลดไฟล์ใหม่อีกครั้ง</div>" +
            "<div class='text-bold'>นามสกุลไฟล์ที่รองรับ " +
            _validFileExtensions.join(", ") +
            "</div>",
          "ปิด"
        );
        onChangeFileValue(null);
        return (formData.winner.fileUpload = null);
      }
    }
  };

  const onUploadFile = (e) => {
    // api update

    onUpdateRoundReward();

    e.preventDefault();
    if (vm.$refs.fileInput?.$el) {
      vm.$refs.fileInput.$el.click();
    } else {
      vm.$refs.fileInput[0].$el.click();
    }

    loading.uploadWinner = true;
    loading.uploadfile = false;
  };

  const onDownloadTemplate = (e) => {
    e.preventDefault();
    if (formData.winner.templateUrl)
      window.location.href = formData.winner.templateUrl;
  };

  const onOpenModalReward = (element) => {
    modalType.reward = true;
    formData.reward.title = element.title;

    vm.$bvModal.show("reward-modal");
    openModal();
  };

  const onCloseModalReward = () => {
    vm.$bvModal.hide("reward-modal");
  };

  const onReorder = () => {
    tableModeReorder.value = !tableModeReorder.value;
    sortableRowOptions.disabled = !sortableRowOptions.disabled;
  };

  const hasSelectWinner = computed(() => {
    return formData.selectedArr.length != 0;
  });

  let seq = 1;
  // add reward
  const addReward = () => {
    onUpdateRoundReward();
    window.$loading(true);
    createReward.payload.RoundId = props.formDataObj.roundId;
    store
      .dispatch("api/apiRequest", createReward)
      .then((response) => {
        const rep = response.data.reward;

        formData.rewardItem.payload.push({
          seq: rep.seq,
          id: rep.rewardid,
          title: rep.title,
          name: rep.reward_name_th || rep.title,
          value: rep.reward_value || 0,
          isdisplay_winner: rep.isdisplay_winner,
          url: rep.image_url,
          status: rep.status,
        });
        const lastIndex = formData.rewardItem.payload.length;
        formData.activeTab = true;
        if (formData.activeTab) {
          toggleActive(formData.rewardItem.payload[lastIndex - 1]);
        }

        checkOverflow();
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onSubmitRoundReward = () => {
    vm.$emit("onSubmitRoundReward", formData);
  };

  const onRemoveReward = (item) => {
    onUpdateRoundReward();
    openWarningModal(
      "ลบ Reward",
      `ต้องการลบรายการ ${item.title} นี้หรือไม่ ?`,
      () => {
        deleteReward.payload.RewardId = item.id;

        store
          .dispatch("api/apiRequest", deleteReward)
          .then((response) => {
            openSuccessModal(
              "ลบรายการสำเร็จ !",
              null,
              "ตกลง",
              () => {
                formData.activeTab = true;
                roundDetail();
              },
              () => {}
            );
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => {});
      }
    );
  };

  const checkOverflow = (isOver) => {
    if (isOver) {
      formData.isOverflowed = true;
    } else {
      formData.isOverflowed =
        (vm.$refs.overflowTabReward
          ? vm.$refs.overflowTabReward.scrollWidth
          : null) >
        (vm.$refs.overflowTabReward
          ? vm.$refs.overflowTabReward.offsetWidth
          : null);
    }
  };

  const dataScroll = reactive({
    isDown: false,
    startX: null,
    scrollLeftX: null,
  });

  let scroll = document.getElementsByClassName("tab-change");

  const mousedownScroll = (e) => {
    dataScroll.isDown = true;
    scroll[0].classList.add("active");
    dataScroll.startX =
      e.pageX -
      (vm.$refs.overflowTabReward
        ? vm.$refs.overflowTabReward.offsetLeft
        : null);
    dataScroll.scrollLeftX = vm.$refs.overflowTabReward
      ? vm.$refs.overflowTabReward.scrollLeft
      : null;
  };

  const mouseleaveScroll = () => {
    dataScroll.isDown = false;
    scroll[0].classList.remove("active");
  };

  const mouseupScroll = () => {
    dataScroll.isDown = false;
    scroll[0].classList.remove("active");
  };

  const mousemoveScroll = (e) => {
    if (formData.reorderData.isReorder && formData.reorderData.tabId) return;
    if (!dataScroll.isDown) return;
    e.preventDefault();
    const x =
      e.pageX -
      (vm.$refs.overflowTabReward
        ? vm.$refs.overflowTabReward.offsetLeft
        : null);

    const walk = x - dataScroll.startX;
    vm.$refs.overflowTabReward.scrollLeft = dataScroll.scrollLeftX - walk;
  };

  const onSubmitWinnerModal = (form) => {
    formData.uploadLoading.value = 0;
    if (loading.uploadWinner) {
      loading.uploadfile = true;
    } else {
      loading.tableData = true;
    }

    const payload = {
      RewardId: formData.reward.rewardId,
      First_Name: form?.firstName,
      Last_Name: form?.lastName,
      Moblie_No: form?.mobileNo,
      Address: form?.address,
      UploadFile: !form ? formData.winner.uploadfile : null,
    };

    createWinner.payload = payload;
    store
      .dispatch("api/apiFormRequest", createWinner)
      .then((response) => {
        if (response.status == "success") {
          openSuccessModal("ทำรายการสำเร็จ !", null, null, null, () => {
            onCloseModalWinner();
            rewardDetail(formData.reward.rewardId);
            formData.winner.file = null;
            if (form) {
              form.address = "";
              form.firstName = "";
              form.lastName = "";
              form.mobileNo = null;
            }
          });
        }
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        loading.uploadfile = false;
        loading.tableData = false;
      });
  };

  const onToggleStatus = (event, item) => {
    formData.rewardItem.payload.map((e) => {
      if (e.id == item.id) {
        e.status = event;
      }
    });
  };

  const onSubmitRewardModal = () => {
    formData.rewardItem.payload.map((e) => {
      if (e.id == formData.reward.rewardId) {
        e.title = formData.reward.title;
      }
    });
    onCloseModalReward();
  };

  const onRemoveWinner = () => {
    onUpdateRoundReward();

    openWarningModal("ลบ Winner", `ต้องการลบรายการ Winner นี้หรือไม่ ?`, () => {
      const payload = {
        RewardId: formData.reward.rewardId,
        WinnerId: formData.selectedArr,
      };
      deleteWinner.payload = payload;

      store
        .dispatch("api/apiRequest", deleteWinner)
        .then((response) => {
          openSuccessModal(
            "ลบรายการสำเร็จ !",
            null,
            "ตกลง",
            () => {
              roundDetail();
            },
            () => {}
          );
        })
        .catch((error) => {
          loading.tableData = false;
          openErrorModal(error);
        })
        .finally(() => {});
    });
  };

  const changeActive = () => {
    formData.activeClass = true;
  };

  function getNumberValidFrom(start, end) {
    if (start && end) {
      let date_1 = resolveReverseDate(start);
      let date_2 = resolveReverseDate(end);
      const date1 = new Date(date_1);
      const date2 = new Date(date_2);
      const oneDay = 1000 * 60 * 60 * 24;

      const diffInTime = date2.getTime() - date1.getTime();
      const diffInDays = Math.round(diffInTime / oneDay);
      formData.calValidFromDate = diffInDays;
    }
  }

  function getNumberValidThrough(start, end) {
    if (start && end) {
      let date_1 = resolveReverseDate(start);
      let date_2 = resolveReverseDate(end);
      const date1 = new Date(date_1);
      const date2 = new Date(date_2);
      const oneDay = 1000 * 60 * 60 * 24;
      const diffInTime = date1.getTime() - date2.getTime();
      const diffInDays = Math.round(diffInTime / oneDay);
      formData.calValidThroughDate = diffInDays;
    }
  }

  const onHoverValidFromDay = (is) => {
    if (is) {
      if (formData.calValidFromDate) {
        formData.isHoverValidFrom = true;
      }
    } else {
      formData.isHoverValidFrom = false;
    }
  };

  const onHoverValidThrough = (is) => {
    if (is) {
      if (formData.calValidThroughDate) {
        formData.isHoverValidThrough = true;
      }
    } else {
      formData.isHoverValidThrough = false;
    }
  };

  const onUpdateProgress = (progress) => {
    if (progress <= 100) {
      formData.uploadLoading.value = progress;
    }
  };

  const hasSelectDel = computed(() => {
    let isHas = false;
    formData.rewardItem.payload.map((e) => {
      if (formData.reward.rewardId == e.id) {
        if (e.winnerListTable?.length != 0) {
          isHas = true;
        }
      }
    });
    return isHas;
  });
  const formatterValue = (e) => {
    const num = e.replace(/\D/g, "");
    return num;
  };

  const onClickReorder = (element) => {
    formData.reorderData.isReorder = true;
    formData.reorderData.tabId = element.id;
  };

  const onClickScroll = (element) => {
    formData.reorderData.isReorder = false;
    formData.reorderData.tabId = 0;
  };

  onBeforeMount(() => {
    onReorder();
    roundDetail();
  });

  return {
    formData,
    flatpickrDateConfig,
    flatpickrTimeConfig,

    toggleActive,
    onHover,
    onUploadMainImg,
    loading,
    pagination,
    fields,
    onFilterEntity,
    onPageChange,
    hasSelectWinner,
    selectAllWinner,
    modalType,
    openWinnerModal,
    onCloseModalWinner,
    onInputFile,
    onUploadFile,
    acceptFile,
    onDownloadTemplate,
    onOpenModalReward,
    onCloseModalReward,
    sortableRowOptions,
    keyChange,
    tableModeReorder,
    addReward,
    onSubmitRoundReward,
    onRemoveReward,
    checkOverflow,
    mousedownScroll,
    mouseleaveScroll,
    mouseupScroll,
    mousemoveScroll,
    onSubmitWinnerModal,
    onSubmitRewardModal,
    changeActive,
    onHoverValidFromDay,
    onHoverValidThrough,
    getNumberValidFrom,
    getNumberValidThrough,
    onRemoveWinner,
    selectItemWinner,
    reorderRewardFunc,
    onUpdateProgress,
    onToggleStatus,
    hasSelectDel,
    formatterValue,
    ConfigflatpickrDateValidFrom,
    ConfigflatpickrValidThrough,
    resolveDate,
    resolveTime,
    reorderRewardStart,
    onClickReorder,
    onClickScroll
  };
}
